import React, { useEffect, useState } from "react";
import { FiCreditCard, FiTruck, FiMapPin, FiShield, FiChevronLeft, FiCheckCircle, FiTag, FiX } from "react-icons/fi";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

function Checkout() {
  const [cartData, setCartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const navigate = useNavigate();
  const [shippingData, setShippingData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });





  // Add these states at the top with your other states
const [serviceability, setServiceability] = useState({
  checked: false,
  isAvailable: false,
  message: ""
});

// Add this useEffect to trigger the check
useEffect(() => {
  const timer = setTimeout(() => {
    if (shippingData.pincode.length === 6) {
      checkDelivery(shippingData.pincode);
    } else {
      setServiceability({ checked: false, isAvailable: false, message: "" });
    }
  }, 500); // Debounce to prevent too many API calls

  return () => clearTimeout(timer);
}, [shippingData.pincode]);

const checkDelivery = async (pin) => {
  try {
    const res = await axios.get(`${baseurl}checkPincodeServiceability/${pin}`);
    if (res.data.success) {
      setServiceability({
        checked: true,
        isAvailable: res.data.serviceable,
        message: res.data.message
      });
    } else {
      setServiceability({
        checked: true,
        isAvailable: false,
        message: res.data.message || "Delivery not available here."
      });
    }
  } catch (err) {
    setServiceability({
      checked: true,
      isAvailable: false,
      message: "Error checking delivery status."
    });
  }
};




  // Coupon States
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [isValidatingCoupon, setIsValidatingCoupon] = useState(false);

  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    if (!customerId) {
      Swal.fire({
        icon: "info",
        title: "Session Expired",
        text: "Please login to continue checkout.",
        confirmButtonColor: "#ed712f",
      }).then(() => navigate("/login"));
      return;
    }
    fetchCart(customerId);
    fetchUser(customerId);
  }, []);

  const fetchCart = async (customerId) => {
    try {
      const res = await axios.get(`${baseurl}getActiveCartByCustomerId/${customerId}`);
      if (res.data.success) setCartData(res.data);
    } catch (err) {
      Swal.fire("Error", "Could not load checkout details.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async (id) => {
    try {
      const res = await axios.get(`${baseurl}getUserById/${id}`);
      if (res.data?.data) {
        const user = res.data.data;
        setShippingData({
          fullName: user.name || "",
          email: user.email || "",
          phone: user.phone || "",
          address: user.address_line1 || "",
          city: user.city || "",
          state: user.state || "",
          pincode: user.postal_code || "",
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Coupon Logic
const handleApplyCoupon = async () => {
  if (!couponCode.trim()) return;
  setIsValidatingCoupon(true);

  try {
    const res = await axios.post(`${baseurl}checkCoupon`, {
      coupon_code: couponCode,
      customer_id: localStorage.getItem("customerId"),
      cart_total: totalPriceBeforeCoupon
    });

    if (res.data.success) {
      const coupon = res.data.data;
      let discount = 0;
      const subtotal = totalPriceBeforeCoupon;

      // Calculate discount logic
      if (coupon.coupon_type === "percentage") {
        discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
      } else {
        discount = parseFloat(coupon.discount_value);
      }

      // Cap discount so it doesn't exceed the total price
      if (discount > subtotal) discount = subtotal;

      setCouponDiscount(discount);
      setAppliedCoupon(coupon);

      // HTML Success Message
      Swal.fire({
        icon: "success",
        title: "Coupon Applied!",
        html: `
          <div style="text-align: center;">
            <p>Code <b>${coupon.coupon_name}</b> is valid.</p>
            <div style="background: #f0fdf4; border: 1px dashed #22c55e; padding: 10px; border-radius: 8px; color: #15803d;">
              <span style="font-size: 1.2rem; font-weight: bold;">₹${discount.toLocaleString()}</span>
              <br/><small>Discount credited to your order</small>
            </div>
          </div>
        `,
        confirmButtonColor: "#ed712f",
      });

    } else {
      // Error from Backend (Expired, Inactive, etc.)
      Swal.fire({
        icon: "error",
        title: "Invalid Coupon",
        html: `<p style="color: #64748b;">${res.data.message || "This coupon code cannot be used."}</p>`,
        confirmButtonColor: "#ef4444",
      });
    }
  } catch (err) {
    // Technical Error
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Failed to validate coupon. Please try again later.",
      confirmButtonColor: "#ef4444",
    });
  } finally {
    setIsValidatingCoupon(false);
  }
};

  const removeCoupon = () => {
    setAppliedCoupon(null);
    setCouponDiscount(0);
    setCouponCode("");
  };

  const handleChange = (e) => setShippingData({ ...shippingData, [e.target.name]: e.target.value });

  const handleCheckout = async (e) => {
  e.preventDefault();
  const customerId = localStorage.getItem("customerId");

  // 1. Validations
  if (!paymentMethod) {
    return Swal.fire("Select Payment", "Please choose a payment method to proceed.", "warning");
  }

  if (serviceability.checked && !serviceability.isAvailable) {
    return Swal.fire("Not Serviceable", "Sorry, we don't deliver to this pincode.", "error");
  }

  setIsProcessing(true);

  // 2. Prepare Totals and Payload
  const totalMRP = cartData.items.reduce((sum, i) => sum + parseFloat(i.product_data.mrp || 0) * i.quantity, 0);
  const totalPriceBeforeCoupon = cartData.items.reduce((sum, i) => sum + parseFloat(i.product_data.price || 0) * i.quantity, 0);
  const finalPayable = totalPriceBeforeCoupon - couponDiscount;

  const orderPayload = {
    cart_id: cartData.cart_id,
    customer_id: customerId,
    vendor_ids: [...new Set(cartData.items.map((i) => i.vendor_id))],
    shipping_details: shippingData,
    payment_method: paymentMethod,
    coupon_id: appliedCoupon ? appliedCoupon.id : null,
    items: cartData.items.map((item) => ({
      product_id: item.product_id,
      variant_id: item.variant_id || null,
      quantity: item.quantity,
      price: item.product_data.price,
      total_price: item.quantity * item.product_data.price,
      vendor_id: item.vendor_id,
    })),
    totals: {
      total_mrp: totalMRP,
      total_discount: (totalMRP - totalPriceBeforeCoupon) + couponDiscount,
      coupon_discount: couponDiscount,
      total_amount: finalPayable,
    },
  };

  try {
    // 3. Create Order on Backend
    const { data: res } = await axios.post(`${baseurl}createOrder`, orderPayload);

    if (!res.success) {
      setIsProcessing(false);
      return Swal.fire("Error", res.message || "Failed to create order.", "error");
    }

    // 4. Handle COD
    if (paymentMethod === "cod") {
      Swal.fire("Order Confirmed", "Your order has been placed successfully via COD.", "success");
      return navigate("/orders");
    }

    // 5. Handle PayU Redirect
    const pd = res.payu_data;
    
    // Create a dynamic form to post to PayU
    const form = document.createElement("form");
    form.method = "POST";
    // For Production use: https://secure.payu.in/_payment
    // For Testing use: https://test.payu.in/_payment
    form.action = "https://secure.payu.in/_payment"; 

    const fields = {
      key: pd.key,
      txnid: pd.txid,
      amount: pd.amount,
      productinfo: pd.productinfo,
      firstname: pd.firstname,
      email: pd.email,
      phone: pd.phone,
      hash: pd.hash,
      surl: pd.surl,
      furl: pd.furl,
    };

    // Append fields to form
    Object.keys(fields).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit(); // This redirects the user to PayU's payment page

  } catch (err) {
    console.error("❌ Checkout Error:", err);
    Swal.fire("Error", "Something went wrong. Please try again.", "error");
    setIsProcessing(false);
  }
};

  if (loading)
    return (
      <div className="checkout-loader">
        <div className="spinner-border text-indigo" />
        <p className="mt-3 fw-medium">Securing your checkout...</p>
      </div>
    );

  const totalMRP = cartData.items.reduce((sum, i) => sum + parseFloat(i.product_data.mrp || 0) * i.quantity, 0);
  const totalPriceBeforeCoupon = cartData.items.reduce((sum, i) => sum + parseFloat(i.product_data.price || 0) * i.quantity, 0);
  const totalSavings = (totalMRP - totalPriceBeforeCoupon) + couponDiscount;
  const finalAmount = totalPriceBeforeCoupon - couponDiscount;

  return (
    <div className="checkout-screen bg-light">
      <div className="container py-4">
        <div className="mb-4 d-flex align-items-center justify-content-between">
          <Link to="/cart" className="back-to-cart">
            <FiChevronLeft /> Back to Cart
          </Link>
          <div className="secure-badge">
            <FiShield className="me-1" /> 100% Secure Checkout
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-8">
            {/* Step 1: Shipping */}
            <div className="checkout-card shadow-sm mb-4">
              <div className="card-header-custom">
                <div className="step-number">1</div>
                <h5 className="mb-0 fw-bold">Shipping Address</h5>
              </div>
              <div className="p-4">
                <div className="row g-3">
                  {Object.keys(shippingData).map((key) => (
                    <>
                    {/* Inside the mapping of shippingData */}
<div className={key === "address" ? "col-12" : "col-md-6"} key={key}>
  <label className="form-label-small">{key.replace(/([A-Z])/g, " $1").toUpperCase()}</label>
  <input
    type="text"
    className={`form-control custom-input ${
      key === "pincode" && serviceability.checked 
        ? (serviceability.isAvailable ? "is-valid" : "is-invalid") 
        : ""
    }`}
    name={key}
    value={shippingData[key]}
    onChange={handleChange}
    placeholder={`Enter ${key}...`}
    disabled={isProcessing}
    maxLength={key === "pincode" ? 6 : undefined}
  />
  
  {/* Show Serviceability Message */}
  {key === "pincode" && serviceability.checked && (
    <div className={`mt-1 small fw-bold ${serviceability.isAvailable ? "text-success" : "text-danger"}`}>
      {serviceability.isAvailable ? (
        <><FiCheckCircle size={12} /> {serviceability.message}</>
      ) : (
        <><FiX size={12} /> {serviceability.message}</>
      )}
    </div>
  )}
</div></>
                  ))}
                </div>
              </div>
            </div>

            {/* NEW: Coupon Code Section */}
            <div className="checkout-card shadow-sm mb-4">
              <div className="card-header-custom">
                <FiTag className="text-indigo" />
                <h5 className="mb-0 fw-bold">Have a Coupon?</h5>
              </div>
              <div className="p-4">
                {!appliedCoupon ? (
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control custom-input"
                      placeholder="Enter promo code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                      disabled={isProcessing}
                    />
                    <button 
                      className="btn btn-indigo-outline px-4 fw-bold"
                      onClick={handleApplyCoupon}
                      disabled={isValidatingCoupon || !couponCode}
                    >
                      {isValidatingCoupon ? "..." : "Apply"}
                    </button>
                  </div>
                ) : (
                  <div className="applied-coupon-box d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="coupon-icon-circle"><FiCheckCircle /></div>
                      <div className="ms-3">
                        <span className="fw-bold d-block">{appliedCoupon.coupon_name}</span>
                        <small className="text-success">Extra ₹{couponDiscount.toLocaleString()} saved!</small>
                      </div>
                    </div>
                    <button className="btn-remove-coupon" onClick={removeCoupon}><FiX /></button>
                  </div>
                )}
              </div>
            </div>

            {/* Step 2: Payment */}
            <div className="checkout-card shadow-sm">
              <div className="card-header-custom">
                <div className="step-number">2</div>
                <h5 className="mb-0 fw-bold">Payment Method</h5>
              </div>
              <div className="p-4">
                <div className="payment-grid">
                  <div
                    className={`payment-box ${paymentMethod === "online" ? "active" : ""} ${isProcessing ? "disabled-box" : ""}`}
                    onClick={() => !isProcessing && setPaymentMethod("online")}
                  >
                    <div className="pay-icon"><FiCreditCard size={24} /></div>
                    <div className="pay-info">
                      <h6>Pay Online</h6>
                      <p>UPI, Cards, Netbanking</p>
                    </div>
                    {paymentMethod === "online" && <FiCheckCircle className="check-mark" />}
                  </div>

                  <div
                    className={`payment-box ${paymentMethod === "cod" ? "active" : ""} ${isProcessing ? "disabled-box" : ""}`}
                    onClick={() => !isProcessing && setPaymentMethod("cod")}
                  >
                    <div className="pay-icon"><FiTruck size={24} /></div>
                    <div className="pay-info">
                      <h6>Cash on Delivery</h6>
                      <p>Pay when you receive</p>
                    </div>
                    {paymentMethod === "cod" && <FiCheckCircle className="check-mark" />}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="summary-card shadow-sm sticky-top">
              <h5 className="fw-bold mb-4">Order Summary</h5>
              <div className="checkout-items-list pe-2">
                {cartData.items.map((item) => {
                  const p = item.product_data;
                  const img = p.images?.length ? `${imgurl}${p.images[0].path}` : "https://via.placeholder.com/100";
                  return (
                    <div key={item.cart_item_id} className="summary-item mb-3">
                      <img src={img} alt={p.name} />
                      <div className="flex-grow-1 ms-3 overflow-hidden">
                        <p className="item-name text-truncate mb-0">{p.name}</p>
                        <small className="text-muted">Qty: {item.quantity}</small>
                      </div>
                      <div className="item-price">₹{(p.price * item.quantity).toLocaleString()}</div>
                    </div>
                  );
                })}
              </div>

              <div className="price-details mt-4">
                <div className="d-flex justify-content-between mb-2">
                  <span>Total MRP</span>
                  <span className="text-muted">₹{totalMRP.toLocaleString()}</span>
                </div>
                <div className="d-flex justify-content-between mb-2 text-success">
                  <span>Item Discount</span>
                  <span>-₹{(totalMRP - totalPriceBeforeCoupon).toLocaleString()}</span>
                </div>
                {couponDiscount > 0 && (
                  <div className="d-flex justify-content-between mb-2 text-success fw-medium">
                    <span>Coupon Savings</span>
                    <span>-₹{couponDiscount.toLocaleString()}</span>
                  </div>
                )}
                <div className="d-flex justify-content-between mb-2">
                  <span>Delivery</span>
                  <span className="text-success fw-medium">FREE</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between total-row">
                  <span className="fw-bold">Payable Amount</span>
                  <span className="fw-bold color-indigo">₹{finalAmount.toLocaleString()}</span>
                </div>
                <div className="mt-3 text-center">
                  <span className="badge bg-success-soft text-success p-2 w-100">
                    You are saving ₹{totalSavings.toLocaleString()} on this order!
                  </span>
                </div>
              </div>

           


              <button
  className="btn-checkout-primary w-100 mt-4 d-flex align-items-center justify-content-center"
  onClick={handleCheckout}
  disabled={isProcessing || (serviceability.checked && !serviceability.isAvailable) || shippingData.pincode.length !== 6}
  style={{
    backgroundColor: (serviceability.checked && !serviceability.isAvailable) ? "#94a3b8" : "#ed712f",
    cursor: (serviceability.checked && !serviceability.isAvailable) ? "not-allowed" : "pointer"
  }}
>
  {isProcessing ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Processing...
    </>
  ) : (
    // Dynamic text based on serviceability
    !serviceability.isAvailable && serviceability.checked 
      ? "Delivery Not Available for this Pincode" 
      : (paymentMethod === "cod" ? "Place COD Order" : "Secure Payment")
  )}
</button>


              <p className="secure-footer-text mt-3">
                <FiShield size={14} /> Your data is protected with 256-bit SSL encryption.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .checkout-screen { min-height: 100vh; color: #1e293b; font-family: 'Inter', sans-serif; }
        .back-to-cart { text-decoration: none; color: #ed712f; font-weight: 500; display: flex; align-items: center; gap: 5px; }
        .secure-badge { background: #dcfce7; color: #15803d; padding: 6px 14px; border-radius: 20px; font-size: 13px; font-weight: 600; display: flex; align-items: center; }
        
        .checkout-card { background: #fff; border-radius: 16px; border: 1px solid #e2e8f0; overflow: hidden; }
        .card-header-custom { background: #f8fafc; padding: 16px 24px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 12px; }
        .step-number { background: #ed712f; color: #fff; width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; }
        
        .custom-input { border: 1.5px solid #e2e8f0; padding: 12px; border-radius: 10px; font-size: 14px; transition: 0.3s; }
        .custom-input:focus { border-color: #ed712f; box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1); }
        .form-label-small { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 6px; }

        .btn-indigo-outline { border: 1.5px solid #ed712f; color: #ed712f; border-radius: 10px; transition: 0.3s; }
        .btn-indigo-outline:hover { background: #ed712f; color: #fff; }

        .applied-coupon-box { background: #f0fdf4; border: 1.5px dashed #22c55e; padding: 15px; border-radius: 12px; }
        .coupon-icon-circle { background: #22c55e; color: #fff; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
        .btn-remove-coupon { background: none; border: none; color: #ef4444; font-size: 20px; }

        .bg-success-soft { background-color: #f0fdf4; }

        .payment-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .payment-box { border: 2px solid #e2e8f0; border-radius: 12px; padding: 20px; cursor: pointer; display: flex; align-items: center; gap: 15px; position: relative; transition: 0.3s; }
        .payment-box.active { border-color: #ed712f; background: #f5f3ff; }
        .disabled-box { opacity: 0.6; cursor: not-allowed; }
        .pay-icon { background: #f1f5f9; width: 48px; height: 48px; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #ed712f; }
        .pay-info h6 { margin: 0; font-weight: 700; font-size: 15px; }
        .pay-info p { margin: 0; font-size: 12px; color: #64748b; }
        .check-mark { position: absolute; top: 12px; right: 12px; color: #ed712f; }

        .summary-card { background: #fff; border-radius: 20px; padding: 24px; border: 1px solid #e2e8f0; top: 20px; }
        .checkout-items-list { max-height: 240px; overflow-y: auto; }
        .summary-item { display: flex; align-items: center; }
        .summary-item img { width: 56px; height: 56px; border-radius: 10px; object-fit: cover; background: #f1f5f9; border: 1px solid #e2e8f0; }
        .item-name { font-size: 14px; font-weight: 600; }
        .item-price { font-weight: 700; font-size: 14px; }
        
        .total-row { font-size: 18px; padding-top: 10px; }
        .color-indigo { color: #ed712f; }
        .btn-checkout-primary { background: #ed712f; color: #fff; border: none; padding: 16px; border-radius: 12px; font-weight: 700; font-size: 16px; transition: 0.3s; box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.4); }
        .btn-checkout-primary:hover:not(:disabled) { background: #4338ca; transform: translateY(-2px); }
        .btn-checkout-primary:disabled { opacity: 0.8; cursor: not-allowed; }
        .secure-footer-text { font-size: 11px; color: #94a3b8; text-align: center; }

        .checkout-loader { height: 80vh; display: flex; flex-direction: column; align-items: center; justify-content: center; }
        .text-indigo { color: #ed712f; }

        @media (max-width: 768px) {
            .payment-grid { grid-template-columns: 1fr; }
            .summary-card { margin-top: 20px; position: static; }
        }
      `}</style>
    </div>
  );
}

export default Checkout;